module.exports = " .sideBody {\r\n    height: 100vh;\r\n    color: #ccc614;\r\n  }\r\n  \r\n  "